import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CompanyInformation = () => {
  const companyDetails = [
    {
      icon: 'MapPin',
      label: 'Hovedkontor',
      value: 'Storgata 15, 0155 Oslo',
      description: 'Norge'
    },
    {
      icon: 'Phone',
      label: 'Kundeservice',
      value: '+47 22 00 00 00',
      description: 'Hverdager 08:00-16:00'
    },
    {
      icon: 'Mail',
      label: 'E-post',
      value: 'kontakt@vei-assistent.com',
      description: 'Svar innen 24 timer'
    }
  ];

  const regulatoryCompliance = [
    {
      title: 'Personvernforordningen (GDPR)',
      status: 'Fullstendig kompatibel',
      date: '15/05/2025',
      icon: 'Shield'
    },
    {
      title: 'Norsk personopplysningslov',
      status: 'Godkjent og overvåket',
      date: '01/01/2025',
      icon: 'FileCheck'
    },
    {
      title: 'Betalingstjenestedirektivet (PSD2)',
      status: 'Sertifisert leverandør',
      date: '10/03/2025',
      icon: 'CreditCard'
    }
  ];

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-card border-2 border-border rounded-[var(--radius-md)] p-6 md:p-8">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading mb-6">
          Selskapsinformasjon
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {companyDetails?.map((detail, index) => (
            <div 
              key={index}
              className="flex items-start gap-4 p-4 bg-surface-elevated rounded-[var(--radius-sm)] border-2 border-transparent hover:border-primary transition-all"
            >
              <div 
                className="flex-shrink-0 w-12 h-12 rounded-[var(--radius-sm)] flex items-center justify-center"
                style={{ background: 'rgba(0, 79, 152, 0.1)' }}
              >
                <Icon
                  name={detail?.icon}
                  size={24}
                  color="var(--color-primary)"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-muted-foreground font-caption mb-1">
                  {detail?.label}
                </h4>
                <p className="text-base md:text-lg font-medium text-foreground font-body mb-1">
                  {detail?.value}
                </p>
                <p className="text-sm text-muted-foreground font-caption">
                  {detail?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-6 border-t-2 border-border">
          <Button
            variant="outline"
            iconName="ExternalLink"
            iconPosition="right"
            onClick={() => window.open('https://www.brreg.no', '_blank')}
            fullWidth
          >
            Verifiser i Brønnøysundregistrene
          </Button>
        </div>
      </div>
      <div className="bg-card border-2 border-border rounded-[var(--radius-md)] p-6 md:p-8">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading mb-6">
          Regulatorisk overholdelse
        </h3>

        <div className="space-y-4">
          {regulatoryCompliance?.map((item, index) => (
            <div 
              key={index}
              className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 md:p-6 bg-surface-elevated rounded-[var(--radius-sm)] border-2 border-border"
            >
              <div className="flex items-start gap-4">
                <div 
                  className="flex-shrink-0 w-10 h-10 rounded-[var(--radius-sm)] flex items-center justify-center"
                  style={{ background: 'rgba(16, 185, 129, 0.1)' }}
                >
                  <Icon
                    name={item?.icon}
                    size={20}
                    color="var(--color-success)"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-base md:text-lg font-semibold text-foreground font-heading mb-1">
                    {item?.title}
                  </h4>
                  <p className="text-sm text-muted-foreground font-caption">
                    {item?.status}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 sm:flex-shrink-0">
                <Icon
                  name="Calendar"
                  size={16}
                  color="var(--color-muted-foreground)"
                />
                <span className="text-sm text-muted-foreground font-data whitespace-nowrap">
                  Oppdatert: {item?.date}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card border-2 border-border rounded-[var(--radius-md)] p-6 md:p-8">
        <div className="flex items-start gap-4">
          <div 
            className="flex-shrink-0 w-12 h-12 rounded-[var(--radius-sm)] flex items-center justify-center"
            style={{ background: 'rgba(0, 79, 152, 0.1)' }}
          >
            <Icon
              name="HelpCircle"
              size={24}
              color="var(--color-primary)"
            />
          </div>
          <div className="flex-1">
            <h4 className="text-lg md:text-xl font-semibold text-foreground font-heading mb-2">
              Har du spørsmål om sikkerhet?
            </h4>
            <p className="text-sm md:text-base text-muted-foreground font-body mb-4">
              Vårt sikkerhetsteam er tilgjengelig for å svare på alle spørsmål om databeskyttelse, sertifiseringer og overholdelse av forskrifter.
            </p>
            <Button
              variant="default"
              iconName="Mail"
              iconPosition="left"
              onClick={() => window.location.href = 'mailto:sikkerhet@veiassistent.no'}
            >
              Kontakt sikkerhetsteam
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyInformation;